import { purchaseStoreInitState } from '../utils/vuex-store-init/purchaseInit.util'

export const state = () => (
  purchaseStoreInitState()
)

export const getters = {
  getTotalPromotionDiscount (state) { // 取得優惠總折扣
    let totalCount = 0
    let promotion = null
    for (const id in state.promotion.selectedOptionByPromotionId) {
      promotion = state.promotion.selectedOptionByPromotionId[id]
      if (promotion && promotion.discount && promotion.discount.DiscountAmount) {
        totalCount += parseInt(promotion.totalCount) * parseInt(promotion.discount.DiscountAmount)
      }
    }
    return totalCount
  },
  uWashContactFlagPriceOptionList (state) {
    if (!this.service.IsNeedCheckContactPickUpFee || !state.contactPickupFeeList.length) return [] // 如未開放電聯，不加入品項
    return state.contactPickupFeeList.map(priceInfo => {
      priceInfo.PriceCount = 1
      return priceInfo
    })
  },
  uWashContactServicePriceTotal (state) {
    if (!this.service.IsNeedCheckContactPickUpFee || !this.uWashContactFlagPriceOptionList.length) return 0
    let priceTotal = 0
    this.uWashContactFlagPriceOptionList.forEach(priceInfo => {
      priceTotal += priceInfo.Price
    })
    return priceTotal
  },
  totalPromotionDiscount (state) { // 取得優惠總折扣
    let totalCount = 0
    for (const [, promotion] of Object.entries(state.promotion.selectedOptionByPromotionId)) {
      if (promotion.discount && promotion.discount.DiscountAmount) {
        totalCount += parseInt(promotion.totalCount) * parseInt(promotion.discount.DiscountAmount)
      }
    }
    return totalCount
  },
  getDateTime (state) {
    return state.selectedData.datetime
  },
  getOptionPriceGroup (state) { // 取得有金額options
    return state.optionPriceGroup
  },
  canGoNext (state) {
    return state.stepValidateList.every(fn => fn())
  },
  // 服務是否為社區模式
  isCommunity (state) {
    return state.service?.serviceAddressMode?.id === 2
  },
  selectedOptionPriceList (state) {
    return state.optionPriceGroup.filter(option => option.optionCount)
  },
  confirmBtnText (state) {
    if (state.service?.order_mode_id === 3) {
      return '確認諮詢'
    }
    return '確認訂購'
  },
  isSetOrderLoading: state => state.btn.isSetOrderLoading,
  canShowPromotion (state) {
    return state.promotion.PromotionDataList.length
  }
}

export const mutations = {
  resetState (state, keepService = true) {
    if (keepService) {
      const service = state.service
      Object.assign(state, {
        ...purchaseStoreInitState(),
        service
      })
    } else {
      Object.assign(state, purchaseStoreInitState())
    }
  },
  setServiceId (state, data) {
    state.serviceId = data
  },
  setServiceData (state, data) {
    state.service = data
  },
  setOptionPriceGroup (state, data) {
    state.optionPriceGroup = data
  },
  setPromotion (state, data) {
    state.promotion = data
  },
  setSelectedData (state, data) {
    state.selectedData = data
  },
  setIsShowCartDialog (state, data = true) {
    state.isShowCartDialog = data
  },
  setStep (state, data) {
    state.step = data
  },
  setContactPickupChecked (state, data) {
    state.contactPickupChecked = data
  },
  setContactPickupFeeList (state, data) {
    state.contactPickupFeeList = data
  },
  setDateTime (state, data) {
    if (!data) return
    state.selectedData.datetime = data
  },
  setRegion (state, data) {
    if (!data) return
    state.selectedData.region = data
  },
  addStepValidate (state, fn) {
    state.stepValidateList.push(fn)
  },
  resetValidateList (state) {
    state.stepValidateList = []
  },
  updateSelectedData (state, { key, subKey, value }) {
    if (subKey) {
      // 支援多層巢狀結構
      const keys = subKey.split('.')
      let target = state.selectedData[key]

      // 遍歷到倒數第二層
      for (let i = 0; i < keys.length - 1; i++) {
        if (!target[keys[i]]) {
          target[keys[i]] = {}
        }
        target = target[keys[i]]
      }

      // 設定最後一層的值
      target[keys[keys.length - 1]] = value
    } else {
      // 更新頂層物件
      state.selectedData[key] = value
    }
  },
  setIsSetOrderLoading (state, value) {
    state.btn.isSetOrderLoading = value
  },
  setSkipLeaveCheck (state, data) {
    state.skipLeaveCheck = !!data
  },
  setSkipLeaveStoreState (state, data) {
    state.skipLeaveStoreState = !!data
  },
  setOrderResult (state, data) {
    state.orderResult = data
  },
  setStepObj (state, data) {
    state.stepObj = data
  },
  setTermChecked (state, data) {
    state.termChecked = data
  },
  setListenStepChange (state, data) {
    state.listenStepChange = data
  },
  setOptionDefaultValue (state, optionGroup) {
    const optionValue = { ...state.selectedData.option }
    optionGroup.forEach(option => {
      if (option.category_option === 2) {
        // 單選
        optionValue[option.category_id] = null
      }
      if (option.category_option === 4) {
        // 複選
        optionValue[option.category_id] = []
      }
      if (option.category_option === 5) {
        // 問答
        optionValue[option.category_id] = ''
      }
    })
    state.selectedData.option = JSON.parse(JSON.stringify(optionValue))
  },
  restoreFromLocal (state) {
    const localData = JSON.parse(localStorage.getItem('purchaseStore'))
    for (const key in state) {
      if (localData[key]) {
        state[key] = localData[key]
      }
    }
  },
  setConfirmPriceDetail (state, data) {
    state.confirmPriceDetail = data
  }
}

export const actions = {
  async validateNextStep ({ state }) {
    for (const fn of state.stepValidateList) {
      const result = await fn()
      if (
        !result ||
        (result.status === 'rejected') ||
        (result.status === 'fufilled' && !result.value)
      ) {
        return false
      }
    }
    return true
  },
  nextStep ({ commit, state }, data) {
    console.log('nextStep trigger')
    commit('setStep', state.step + 1)
  },
  setServiceTimeDefaultMode ({ commit, state }, data) {
    const getServiceTimeDefaultMode = () => {
      const defaultMode = [
        { value: 1, label: '早上' },
        { value: 2, label: '下午' },
        { value: 4, label: '晚上' }
      ].filter(mode => state.service.reservation.indexOf(mode.value) > -1)
      if (defaultMode.length === 0) {
        commit('setDateTime', {
          ...state.selectedData.datetime,
          defaultTime: 7
        })
        return [{ value: 7, label: '皆可' }]
      } else {
        commit('setDateTime', {
          ...state.selectedData.datetime,
          defaultTime: defaultMode[0].value
        })
        return defaultMode.length > 1 ? [...defaultMode, { value: 7, label: '皆可' }] : defaultMode
      }
    }

    if ([1, 10].includes(state.service.serviceTimeType.id)) {
      commit('setDateTime', {
        ...state.selectedData.datetime,
        defaultModeList: getServiceTimeDefaultMode()
      })
    }
    if (state.service.serviceTimeType.id === 10) {
      commit('setDateTime', {
        ...state.selectedData.datetime,
        weekdayOrWeekendModeList: [
          {
            value: 1,
            label: '平日'
          },
          {
            value: 2,
            label: '假日'
          },
          {
            value: 3,
            label: '皆可'
          }
        ]
      })
    }
  },
  storeToLocal ({ state }) {
    localStorage.setItem('purchaseStore', JSON.stringify(state))
  },
  removeLocalData () {
    localStorage.removeItem('purchaseStore')
  },
  async fetchPromotionData ({ commit, state }, serviceId) {
    const { data } = await this.$axios.get('/api/Promotion/GetPromotionDataByServiceId', { params: { service_id: serviceId } })
      .catch(error => {
        return Promise.reject(error)
      })
    const processedPromotionList = data.Data.PromotionDataList.map(promotion => ({
      ...promotion,
      maxDiscount: promotion.DetailList.reduce((maxAmount, detail) => {
        return detail.DiscountAmount > maxAmount ? detail.DiscountAmount : maxAmount
      }, 0)
    }))
    commit('setPromotion', {
      selectedOptionByPromotionId: {},
      selectingOptionByPromotionId: {},
      PromotionDataList: processedPromotionList
    })
  }
}
